import React, { useEffect } from "react";
import { Form, Col, Row, Button, Select, Collapse, Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper"; // Helper'ın içinde 'eq' fonksiyonu olduğunu varsayıyorum.

const MaterialCategoryTableFilter = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    let query = "";
    const conditions = [];

    if (values.name) {
      if (values.level) {
        // Seviye seçiliyse: o seviyedeki kayıt için tam yol (totalName) üzerinden ara
        conditions.push(odata.contains("totalName", values.name));
      } else {
        // Sadece isim: ana kategori + tüm alt seviyeler
        conditions.push(odata.contains("mainCategoryName", values.name));
      }
    }

    if (values.level) {
      conditions.push(`level eq ${values.level}`);
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }

    if (props.onFinishFilter) props.onFinishFilter(query, values);
  };

  const clearFilter = () => {
    form.resetFields();
    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }} gutter={16}>
                {/* İsim Arama */}
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label={"Kategori Adı :"} name="name">
                    <Input placeholder="Kategori adı girin" />
                  </Form.Item>
                </Col>

                {/* YENİ ALAN: Seviye Bazlı Seçim */}
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label={"Kategori Seviyesi :"} name="level">
                    <Select allowClear placeholder="Seçiniz">
                      <Select.Option value={1}>1. Seviye (Ana Kategori)</Select.Option>
                      <Select.Option value={2}>2. Seviye</Select.Option>
                      <Select.Option value={3}>3. Seviye</Select.Option>
                      <Select.Option value={4}>4. Seviye</Select.Option>
                      <Select.Option value={5}>5. Seviye</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                    style={{ marginRight: 8 }}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{
                      color: "#fff",
                      borderColor: "#40a9ff",
                      backgroundColor: "#40a9ff",
                    }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};

export default MaterialCategoryTableFilter;